import EntityContentItemMediaForm from './EntityContentItemMediaForm';

export default EntityContentItemMediaForm;
